import Option from '@/components/form/types/Option.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { fieldDisplayNames } from '@/components/table/_fieldDefinitions/fieldDisplayNames.ts';

/**
 * Pola do wyboru w panelu filtrów. Schowane pole zostaje, gdy stosowany filtr go używa — wiersz z adresu
 * musi mieć nazwę i dać się usunąć.
 */
export const filterFieldOptions = (
  tableDef: TableDefinitionDto,
  activeFieldIds: string[],
): Option[] =>
  tableDef.fields
    .filter(
      (field) =>
        field.filterable &&
        (!field.hiddenInFilterPanel || activeFieldIds.includes(field.fieldId)),
    )
    .map((field) => ({
      value: field.fieldId,
      label: field.customField
        ? field.fieldName
        : (fieldDisplayNames[field.fieldId] ?? field.fieldId),
    }));
